import React, { useState, useEffect } from 'react';
import { Navigate, useParams } from "react-router-dom";

import { Button } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  Campaign, 
} from "@dndModels";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import LoadingBox from "@components/input/LoadingBox";

import CampaignDecksInput from "@dndComponents/character/campaign_deck/CampaignDecksInput";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function CampaignDecks() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [logging_in, setLoggingIn] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<Campaign>(new Campaign());
  const [do_submit, setDoSubmit] = useState(false);
  
  // eslint-disable-next-line
  useEffect(() => {
    if(!fetched) {
      setFetched(true);
      if (api.user === null) {
        const userObjStr = localStorage.getItem("loginUser");
        if (!userObjStr) {
          setNavigateTo("/");
        } else {
          setLoggingIn(true);
          check_login();
        }
      } else {
        load();
      }
    }
  });
    
  useEffect(() => {
    if (do_submit) {
      setDoSubmit(false);
      submit();
    }
    // eslint-disable-next-line
  }, [do_submit]);

  const check_login = () => {
    setTimeout(() => {
      if (api.user === null) {
        check_login();
      } else {
        setLoggingIn(false);
        load();
      }
    }, 1000);
  }

  const submit = () => {
    setProcessing(true);
    const last_updated = common_util.get_time_number();
    obj.last_updated = last_updated;
    if (obj._id && obj._id !== "") {
      api.updateObject("campaign", obj).then(res => {
        setProcessing(false);
      });
    } else {
      obj.owner_id = api.user ? api.user._id : "No Login";
      api.createObject("campaign", obj).then(res => {
        setProcessing(false);
      });
    }
  }

  const load_object = (id: string) => {
    setLoading(true);
    api.getObjects({ data_type: "campaign", filter: { "_id*ObjectIDs": [id] } }).then(res => {
      if (res.length === 1 && res[0] instanceof Campaign) {
        const new_obj = res[0];
        setObj(new_obj);
        setLoading(false);
      }
    });
  }

  const load = () => {
    if (id && id !== "") {
      setLoading(true);
      load_object(id);
    } else {
      console.error("It should never come here");
    }
  }
  
  const height = window.innerHeight - 64;
  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else if (!api.online) {
    return (
      <>Campaign Decks only work while online.  Try reconnecting.</>
    );
  } else if (!fetched || loading || logging_in) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else { 
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <Button variant="contained" color="primary" style={{marginLeft: "8px"}}
            onClick={ () => {
              setNavigateTo(`/campaign`);
            }}>
            Back to Campaigns
          </Button> 
          <Button variant="contained" color="primary" style={{marginLeft: "8px"}}
            onClick={ () => {
              setNavigateTo(`/campaign/details/${obj._id}`);
            }}>
            Back to details for {obj.name}
          </Button> 
          { api.user !== null && (obj.owner_id === api.user._id || api.user.admin) &&
            <Button variant="contained" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                setNavigateTo(`/campaign/${obj._id}`);
              }}>
              Edit {obj.name}
            </Button> 
          }
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <CampaignDecksInput 
            campaign={obj}
            disabled={processing}
            onChange={(new_obj: Campaign) => {
              setObj(new_obj);
              setDoSubmit(true);
            }}
          />
        </Grid>
      </Grid>
    ); 
  }
}